import { Differentiation } from 'approot/shared/differentiation/differentiation.constants';
import { getDifferentiatedAssessmentTitle } from 'approot/shared/logic/get-differentiated-assessment-title';
import { ActivitiesContentType, ASSESSMENT_ACTIVITIES } from 'global/constants';

export function getActivityTitle({
  activityNumber,
  progressLabel,
  differentiation,
  totalSteps,
  contentType,
  unitQuizLabel,
}: {
  differentiation: Differentiation | null;
  activityNumber: number;
  totalSteps: number;
  progressLabel: string;
  contentType: ActivitiesContentType;
  unitQuizLabel: string;
}) {
  if (contentType === ASSESSMENT_ACTIVITIES) {
    return {
      title: `Activity ${activityNumber}${
        totalSteps > 1 ? ` (${progressLabel})` : ''
      }`,
      description: getDifferentiatedAssessmentTitle(
        differentiation,
        unitQuizLabel
      ),
    };
  }
  return {
    title: `Activity ${activityNumber}${
      totalSteps > 1 ? ` (${progressLabel})` : ''
    }`,
    description: null,
  };
}
